import { useContext } from 'react';
import { PluginApiContext } from './PluginApiContext';
import type { PluginApiClient } from './types';

export function usePluginApiClient(): PluginApiClient {
  const client = useContext(PluginApiContext);
  if (client === null) {
    throw new Error(
      'usePluginApiClient: no PluginApiProvider in the tree. ' +
        'Wrap the consumer in <PluginApiProvider client={...}>.',
    );
  }
  return client;
}
